import * as React from "react";
import { Box as MantineBox } from "@mantine/core";
const Box = ({ ...props }) => /* @__PURE__ */ React.createElement(MantineBox, { ...props });
export default Box;
